import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { AppointmentService } from '@avanta/shared/services/appointments';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { mapToLabelValue } from 'utils/common';

export type Option = { value: string | number; label: string };

export const useFetchEspecialities = (userId: string): UseQueryResult<Option[]> =>
  useQuery({
    queryKey: [QUERY_KEYS.FETCH_SPECIALITIES],
    queryFn: () => AppointmentService.getSpecialities(userId),
    select: response =>
      mapToLabelValue(
        response.data as unknown as Record<string, string>[],
        'id',
        'name',
        'Chat.UserInfo.Coupons.Form.speciality.options',
        LOCIZE_NS.CHAT
      ),
    enabled: !!userId,
  });
